import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import('./lazyIndex'), {
    name: 'OwaCalendarConfiguration',
});

export const lazySyncConfigToCalendarCache: LazyAction<
    typeof lazyIndex.syncConfigToCalendarCache,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.syncConfigToCalendarCache);
